import React, { useState } from 'react';
import { Modal, Tooltip, Radio, Checkbox } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Row, Widget, Col } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import './modal.css';
import { recusarDocumento } from '@app/api/ContabilidadeGeral';

export interface propsModalRecusar {
  arquivoAutorizacaoId: string;
  updatePage: any;
}

const optionsMotivo = [
  {
    value: 'cnpjIncorreto',
    label: 'CNPJ Incorreto.',
  },
  {
    value: 'valorIncorreto',
    label: 'Valor Incorreto.',
  },
  {
    value: 'impostos',
    label: 'Impostos.',
  },
  {
    value: 'descricao',
    label: 'Descrição.',
  },
  {
    value: 'erroRateio',
    label: 'Erro na OI/OM/CC/CR/Natureza.',
  },
  {
    value: 'outros',
    label: 'Outros.',
  },
];

const ModalRecusar = (props: propsModalRecusar) => {
  const { arquivoAutorizacaoId, updatePage } = props;
  const [exibirModal, setExibirModal] = useState(false);
  const [motivo, setMotivo] = useState('');
  const [justificativa, setJustificativa] = useState('');

  const handleSubmit = () => {
    recusarDocumento({ justificativa, arquivoAutorizacaoId, motivo }).then(data => {
      if (data) {
        setExibirModal(false);
        updatePage();
      }
    });
  };

  return (
    <>
      <Tooltip title="Recusar Documento">
        <Button
          onClick={() => {
            setExibirModal(true);
          }}
          icon="commons-cancel_2"
          name="btnRecusar"
        />
      </Tooltip>
      <Modal
        title="Recusar Documento"
        // className="chat-modal"
        width="900px"
        visible={exibirModal}
        onCancel={() => {
          setExibirModal(false);
        }}
        footer={null}>
        <MasterDetailForm
          key="formModalRecusar"
          actions={[
            <Button
              type='link'
              onClick={() => {
                setExibirModal(false);
              }}>
              Fechar
            </Button>,
            <Button
              onClick={() => handleSubmit()}
              type="primary"
              disabled={!hasPermission(['MEDICAO_AUTORIZACAO_PAGAMENTO_EDITAR'])}>
              <FormatText id="ui.commons.save" uppercase />
            </Button>,
          ]}>
          <Widget id="listImpactos">
            <Row>
              <Col>
                <label>Motivo</label>
              </Col>
              <Row style={{ marginLeft: '10px' }}>
                <Col>
                  <Radio.Group name="Motivo" options={optionsMotivo} onChange={e => setMotivo(e.target.value)} />
                </Col>
              </Row>
            </Row>

            <Row>
              <Col>
                <label>Impacto para o Fornecedor</label>
              </Col>
              <Row style={{ marginLeft: '10px' }}>
                <Col>
                  <Checkbox checked={motivo == 'outros' ? true : false} disabled={motivo == 'outros' ? false : true}>
                    Solicitar substituição de Documento de Cobrança
                  </Checkbox>
                </Col>
                <Col>
                  <Checkbox
                    checked={motivo == 'descricao' ? true : false}
                    disabled={motivo == 'descricao' ? false : true}>
                    Solicitar anexação da Carta de Correção
                  </Checkbox>
                </Col>
                <Col>
                  <Checkbox
                    checked={
                      motivo == 'cnpjIncorreto' || motivo == 'valorIncorreto' || motivo == 'impostos' ? true : false
                    }
                    disabled={
                      motivo == 'cnpjIncorreto' || motivo == 'valorIncorreto' || motivo == 'impostos' ? false : true
                    }>
                    Solicitar o Cancelamento/Substituição do Documento de Cobrança
                  </Checkbox>
                </Col>
                <Col>
                  <Checkbox
                    checked={motivo == 'erroRateio' ? true : false}
                    disabled={motivo == 'erroRateio' ? false : true}>
                    Devolver para o Responsável pelo Rateio
                  </Checkbox>
                </Col>
              </Row>
            </Row>
            <Row>
              <Col>
                <label>Justificativa</label>
              </Col>
              <Col>
                <FormTextArea
                  name="justificativa"
                  value={justificativa}
                  onChange={e => setJustificativa(e.target.value)}
                  span={12}
                  rows={4}
                  maxLength={2000}
                />
              </Col>
            </Row>
          </Widget>
        </MasterDetailForm>
      </Modal>
    </>
  );
};
export default ModalRecusar;
